import { render, staticRenderFns } from "./OrderFormStep6DateOfDeathTab.module.vue?vue&type=template&id=451b140e&scoped=true&"
import script from "./OrderFormStep6DateOfDeathTab.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6DateOfDeathTab.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6DateOfDeathTab.module.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderFormStep6DateOfDeathTab.module.vue?vue&type=style&index=1&id=451b140e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b140e",
  null
  
)

export default component.exports